import { AxiosInstance } from "axios";

export const AgendaUrlService = (axiosInstance: AxiosInstance) => {
    const apiBaseUrl = "api/agenda";

  return {
    getOne: async (agendaId: string, ) => {
      return await axiosInstance.get(`${apiBaseUrl}/${agendaId}`,).then((result) => result.data);
    },
  };
};
